import { render, staticRenderFns } from "./ProcessInfo.vue?vue&type=template&id=5f63fcc9&scoped=true&"
import script from "./ProcessInfo.vue?vue&type=script&lang=js&"
export * from "./ProcessInfo.vue?vue&type=script&lang=js&"
import style0 from "./ProcessInfo.vue?vue&type=style&index=0&id=5f63fcc9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f63fcc9",
  null
  
)

export default component.exports